import { AddLineDrawer } from './AddLineDrawer';
import { ChangeLineDrawer } from './ChangeLineDrawer';
import { LineHistoryDrawer } from './LineHistoryDrawer';
import type { RateLineView } from '../../../rate-cards.api';

export type LineDialog = { kind: 'add' } | { kind: 'change'; line: RateLineView } | { kind: 'history'; line: RateLineView };

interface LineDialogsProps {
  dialog: LineDialog | null;
  rateCardId: string;
  onClose: () => void;
}

/** The Lines tab's three overlays: add a line, change a price, read a price's history. At most one is open. */
export function LineDialogs({ dialog, rateCardId, onClose }: LineDialogsProps) {
  return (
    <>
      <AddLineDrawer open={dialog?.kind === 'add'} rateCardId={rateCardId} onClose={onClose} />
      <ChangeLineDrawer line={dialog?.kind === 'change' ? dialog.line : null} onClose={onClose} />
      <LineHistoryDrawer line={dialog?.kind === 'history' ? dialog.line : null} onClose={onClose} />
    </>
  );
}
